define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  //This will set an auto generated temporary password
  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portal/featuresActivation/',
    url: function() {
      return this.urlRoot+this.featureId;
    }
  });
});
